import { useEffect, useState } from "react";
import {
  BannerSection,
  SliderSection,
  InfoSection,
  EarnSection,
  DataSection,
  ProvenTeamSection,
  TimelineSection,
  ChartSection,
  TeamSection,
  AboutSection
} from "../components/index";

function LandingPage() {

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  return (
    <>
      <BannerSection isMobile={isMobile}></BannerSection>
      <SliderSection></SliderSection>
      <InfoSection isMobile={isMobile}></InfoSection>
      <DataSection></DataSection>
      <EarnSection isMobile={isMobile}></EarnSection>
      <ChartSection></ChartSection>
      <TimelineSection></TimelineSection>
      <ProvenTeamSection></ProvenTeamSection>
      <TeamSection></TeamSection>
      <AboutSection isMobile={isMobile}></AboutSection>
    </>
  );
}

export default LandingPage;
